import { render, staticRenderFns } from "./AlertContent.vue?vue&type=template&id=1a84c0b0"
import script from "./AlertContent.vue?vue&type=script&lang=js"
export * from "./AlertContent.vue?vue&type=script&lang=js"
import style0 from "./AlertContent.vue?vue&type=style&index=0&id=1a84c0b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports